module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC0SURBVDiNrdLREcIgDIDhvzqJk4ibuInpZLST6YNwh0ISWshdrnloviaUBT1Cynt6AmzAnmoxeisoAm8npfiQGtIBteBpmIqGASznz/o9Z+ZlnLFqNeVFO9AiVuABLKm2InjrSqPJ2ijirKBNYfZYEwYFVUHvDFugGO+vV+BmTBL4/owt1U/gZYB7bpp2bbI842LL/2qjYBUya7pRVMXOoC52BO3GetDDmIWexlroMFaiXdgHB0oBc/k9H2wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/add-icon.png
// module id = I0c5
// module chunks = 1